import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {ChatRoomsEnum} from 'presentation/constants';
import {useHostName} from 'presentation/hooks';
import {UNITS_CHANNELS_CONTACTS} from 'presentation/modules/booking/shared/constants/unitsChannelsContacts';
import {MAX_DISTANCE_FILTER_UNITS} from 'presentation/modules/booking/shared/constants/unitsInfo';
import {useBookingSummary} from 'presentation/modules/booking/shared/hooks/useBookingSummary';
import {useOpenDrawerFilterStore} from 'presentation/modules/booking/shared/store/useOpenDrawerFilterStore';
import {ChangeFlowVariantEnum} from 'presentation/modules/booking/shared/ui/components/ChangeFlowDialog/constants';
import {useCallChatRoom, useMediaQueries, useQueryParams} from 'presentation/pages';

import {translations} from 'presentation/translations-new';
import React, {useState} from 'react';

const {unitsFlow} = translations['pt-br'].privateFlow.bookingFlow;
const {choosePhoneNumber} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow.unitDetails;
const {changeAppointmentLocal} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow;

export function useExamUnitsNotFoundState() {
	const {isMobile} = useMediaQueries();
	const {SEARCH_PARAMS} = useQueryParams();
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [openPhoneDrawerState, setOpenPhoneDrawerState] = useState(false);
	const {callChatRoom, IS_LOADING: callChatRoomIsLoading} = useCallChatRoom();
	const {dataHostNameState} = useHostName();
	const {handleChangeModals} = useBookingSummary();
	const setOpenDrawerState = useOpenDrawerFilterStore(state => state.setOpenDrawerState);
	const {localityDistance} = SEARCH_PARAMS;

	const distanceFilterAtMaxDistance = Number(localityDistance) >= MAX_DISTANCE_FILTER_UNITS;
	const isPhoneNumberMenuOpen = Boolean(anchorEl);
	const emptyDescription = distanceFilterAtMaxDistance
		? unitsFlow.notFoundModal.contactSupportExam
		: unitsFlow.notFoundModal.descriptionExam;
	const phoneNumbersAlert = UNITS_CHANNELS_CONTACTS[dataHostNameState.product].alert;
	const phoneNumbers = UNITS_CHANNELS_CONTACTS[dataHostNameState.product].phones;

	const handleOpenPhoneMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
		if (isMobile) {
			setOpenPhoneDrawerState(true);
			return;
		}
		setAnchorEl(event.currentTarget);
	};

	const handleTogglePhoneDrawer = () => {
		setOpenPhoneDrawerState(prev => !prev);
	};

	const handleClosePhoneMenu = () => {
		setAnchorEl(null);
	};

	const handleOpenDrawer = () => {
		setOpenDrawerState(true);
	};

	const handleChangeLocation = () => handleChangeModals(ChangeFlowVariantEnum.LOCATION);

	const handleCallChatRoom = async () => {
		await callChatRoom(ChatRoomsEnum.EXAMS);
	};

	const primaryButtonConfig = {
		label: distanceFilterAtMaxDistance
			? changeAppointmentLocal
			: unitsFlow.searchNearbyUnitsHealthExam,
		action: distanceFilterAtMaxDistance ? handleChangeLocation : handleOpenDrawer,
		dataTagId: distanceFilterAtMaxDistance
			? AppointmentBookingEnum.CLICK_ALTERAR_LOCAL_ATENDIMENTO_AGENDAMENTO
			: AppointmentBookingEnum.CLICK_BUSCAR_UNIDADES_PROXIMAS,
	};

	return {
		emptyDescription,
		primaryButtonConfig,
		handleCallChatRoom,
		handleOpenPhoneMenu,
		isMobile,
		openPhoneDrawerState,
		handleTogglePhoneDrawer,
		choosePhoneNumber,
		phoneNumbersAlert,
		phoneNumbers,
		isPhoneNumberMenuOpen,
		anchorEl,
		handleClosePhoneMenu,
		callChatRoomIsLoading,
	};
}
